var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.labelSize),function(size,i){return _c('b-dropdown-item',{key:i,attrs:{"href":_vm.setTypeUrlLabel( size.key, false ),"target":"_blank"}},[_vm._v("\n        "+_vm._s(size.name)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }